import { parseStringWithOptions } from '@lessonup/utils';
import { PlayerStore } from '../../playerStore.types';

export function normalizeAnswer(answer: string): string {
  return parseStringWithOptions(answer, { asLowercase: true, normalizeDiacritics: true });
}

export function areAllWordCloudAnswersRevealed(store: PlayerStore): boolean {
  const currentPinId = store.currentPinId();
  if (!currentPinId) {
    return false;
  }

  const currentPinState = store.currentPinState();
  if (!currentPinState || !currentPinState.wordCloud) {
    return false;
  }

  const wordCloudData = currentPinState.wordCloud;

  if (!wordCloudData.answers || wordCloudData.answers.length === 0) {
    return true;
  }
  if (!wordCloudData.revealedAnswers) {
    return false;
  }
  if (wordCloudData.answers.length > wordCloudData.revealedAnswers.length) {
    return false;
  }
  const revealedAnswersSet = new Set(wordCloudData.revealedAnswers);
  return wordCloudData.answers.every((answer) => revealedAnswersSet.has(answer.text));
}
